// 视频课程
import courseIndex from '@/views/study/course/index'

const zsxxwRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `course/zsxxw/index${i + 1}`,
  name: `course/zsxxw/Index${i + 1}`,
  component: () => import(`@/views/study/course/zsxxw/index${i + 1}.vue`)
}))

export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'course/index',
      name: 'courseIndex',
      component: courseIndex
    },
    // 视频课程，开始
    ...zsxxwRoutes
    // 视频课程，结束

  ]
}
